import { Inject, Pipe, PipeTransform } from "@angular/core";
import { TableDataPointType } from '@core/data/types/Reports/report-tables';
import { Library } from '@library';
import { LIBRARY } from '../library';

@Pipe({
    name: 'describeTableDataPoint'
})
export class DescribeTableDataPoint implements PipeTransform{
    constructor(
        @Inject(LIBRARY) private _library: Library,
    ) {}

    transform(id: string, type: TableDataPointType) {
        let label = id;

        if (type === TableDataPointType.CALCULATION) label = this._library.calculations.get(id)?.label;
        if (type === TableDataPointType.CHARACTERISTIC) label = this._library.chars.get(id)?.label;
        if (type === TableDataPointType.INDEX) label = this._library.indexes.get(id)?.label;
        if (type === TableDataPointType.MEASUREMENT) label = this._library.measures.get(id)?.label;
        if (type === TableDataPointType.PROPERTY) label = this._library.properties.get(id)?.label;
        if (type === TableDataPointType.CLASSIFICATION) label = this._library.classifications.get(id)?.label;

        return label;
    }
}